// extracted by mini-css-extract-plugin
export default {"container":"Es-z","heading":"Fs-z","text":"Gs-z","info":"Hs-z","link":"Is-z","fullMaxWidth":"Js-z"};